// extracted by mini-css-extract-plugin
export var orderDetails = "_rk-2";
export var orderImage = "_rk-1";
export var orderMeta = "_rk-3";
export var orderSummary = "_rk-0";
export var rightArrow = "_rk-4";